export const tableWrapperSx = {
  display: 'flex',
  alignItems: 'start',
  width: '100%',
  minWidth: '100%',
  position: 'relative',
  border: '1px solid var(--border-color)',
  borderRadius: 1,
  overflow: 'hidden',
};

export const droppableRowSx = {
  display: 'flex',
  flex: 1,
  overflowX: 'auto',
};

export const columnBoxSx = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  borderRight: '1px solid rgb(251, 251, 251)',
  backgroundColor: '#fff',
};

export const sortTableCellSx = {
  borderRight: '1px solid rgb(251, 251, 251)',
  '&:hover .drag-icon': {
    visibility: 'visible',
  },
};

export const sortCellInnerSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  cursor: 'pointer',
};

export const dragIconSx = {
  minWidth: 20,
  display: 'flex',
  alignItems: 'center',
  mr: 1,
};

export const swapIconSx = {
  display: 'flex',
  alignItems: 'center',
  minWidth: 20,
  ml: 0.5,
  visibility: 'hidden',
};
